(function () {
    'use strict';

    angular
        .module('app')
        .service('videoService', videoService);

    videoService.$inject = ['$http'];

    function videoService($http) {
        /* jshint validthis:true */
        var vm = this;
        var baseUrl = '/api/videos';

        vm.getVideoData = getVideoData;
        function getVideoData(take, skip) {
            //alert("service");
            return $http({
                url: baseUrl + '/get-videos',
                method: "GET",
                params: { take: take, skip: skip }
            });
            //return $http.get(baseUrl + '/get-articles');
        }
    }
})();